import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useRemoveDisplayWebContent = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback((id: string) => dispatch({ type: 'REMOVE_DISPLAY_WEBSITE_CONTENT', payload: { id } }), [dispatch]);
};
